(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cocora-science"] && !Shopify.designMode) return;
  try {
    
(() => {
  let dispose = () => {};
  function initializeCocoraScience() {
    dispose();
    const root = document.querySelector('[data-cs-home]');
    if (!root) return;
    const controller = new AbortController();
    const signal = controller.signal;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const motion = root.querySelector('[data-cs-motion]');
    let paused = reduced.matches;
    try { paused = paused || sessionStorage.getItem('cocora-science-motion') === 'off'; } catch (_) {}
    let revealObserver;
    let stageObserver;
    if ('IntersectionObserver' in window) {
      root.classList.add('cs-enhanced');
      revealObserver = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.add('cs-visible'); revealObserver.unobserve(entry.target); }
      }), { threshold: 0.06 });
      root.querySelectorAll('[data-cs-reveal]').forEach(el => revealObserver.observe(el));
      stageObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          root.querySelectorAll('[data-cs-stage-link]').forEach(link => {
            if (link.dataset.csStageLink === entry.target.dataset.csStage) link.setAttribute('aria-current', 'step');
            else link.removeAttribute('aria-current');
          });
        });
      }, { rootMargin: '-25% 0px -40% 0px', threshold: 0 });
      root.querySelectorAll('[data-cs-stage]').forEach(el => stageObserver.observe(el));
    }
    const layers = [...root.querySelectorAll('[data-cs-parallax]')];
    let frame = 0;
    function draw() {
      frame = 0;
      if (paused || document.hidden) return;
      layers.forEach(layer => {
        const rect = layer.parentElement.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > innerHeight) return;
        const scale = innerWidth < 800 ? 0.4 : 1;
        const offset = (innerHeight / 2 - rect.top - rect.height / 2) * Number(layer.dataset.csParallax) * scale;
        const limit = rect.height * 0.08;
        layer.style.transform = `translate3d(0,${Math.max(-limit, Math.min(limit, offset))}px,0)`;
      });
    }
    const queue = () => { if (!frame && !paused) frame = requestAnimationFrame(draw); };
    function updateMotion() {
      root.classList.toggle('cs-paused', paused);
      motion.textContent = paused ? motion.dataset.enable : motion.dataset.pause;
      motion.setAttribute('aria-pressed', String(paused));
      if (paused) { if (frame) cancelAnimationFrame(frame); frame = 0; layers.forEach(layer => layer.style.transform = ''); }
      else queue();
    }
    motion.addEventListener('click', () => { paused = !paused; try { sessionStorage.setItem('cocora-science-motion', paused ? 'off' : 'on'); } catch (_) {} updateMotion(); }, { signal });
    reduced.addEventListener('change', event => { paused = event.matches; updateMotion(); }, { signal });
    window.addEventListener('scroll', queue, { passive: true, signal });
    window.addEventListener('resize', queue, { passive: true, signal });
    document.addEventListener('visibilitychange', queue, { signal });
    updateMotion();
    dispose = () => { controller.abort(); revealObserver?.disconnect(); stageObserver?.disconnect(); if (frame) cancelAnimationFrame(frame); };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeCocoraScience, { once: true });
  else initializeCocoraScience();
  document.addEventListener('shopify:section:load', initializeCocoraScience);
  document.addEventListener('shopify:section:unload', event => { if (event.target.querySelector('[data-cs-home]')) dispose(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
